/**
 * @deprecated Use lodash `_.noop()` instead.
 */
export const noop = () => null
